import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';

import environment from '@config/environment';

const APP_VERSION = '7.2.0';
const GTM_CLICK_EVENT = 'gtm.click';
let userID: string | null = null;
let userEmail: string | null = null;

const GA_CONFIG = {
  ga_tracking_id: environment.GA_TRACKING_ID,
  app_version: APP_VERSION,
};

const GTM_CONFIG = {
  gtmId: environment.GTM_CONTAINER_ID,
  auth: environment.GTM_AUTH,
  preview: environment.GTM_PREVIEW,
  dataLayer: {
    ...GA_CONFIG,
    app_version: APP_VERSION,
  },
};

const initialize = () => {
  TagManager.initialize(GTM_CONFIG);
  ReactGA.initialize(environment.GA_TRACKING_ID);

  ReactGA.set({
    appVersion: APP_VERSION,
    user_agent: userEmail,
    user_properties: {
      user_id: userID,
      user_email: userEmail,
      email: userEmail,
    },
  });
};

const trackEvent = (category: string, action: string) => {
  ReactGA.event({
    category,
    action,
  });

  TagManager.dataLayer({
    dataLayer: {
      event: GTM_CLICK_EVENT,
      category,
      action,
      user_id: userID,
      user_agent: userEmail,
      user_email: userEmail,
      user_properties: {
        user_id: userID,
        user_email: userEmail,
        email: userEmail,
      },
    },
  });
};

const setUserValues = ({ userId, email }: { userId: string; email: string; }) => {
  userID = userId;
  userEmail = email;
}

export default { initialize, trackEvent, setUserValues };
